export const socialShareTypes = {
    EMAIL: "email",
    LINKEDIN: "linkedIn",
    TWITTER: "twitter",
    FACEBOOK: "facebook",
    WHATSAPP: "whatsapp",
};

export const socialShareOptions = [
    {
        id: socialShareTypes.EMAIL,
        label: "E-mail",
        icon: "cleverstory-mail",
        url: "https://mail.google.com/",
    },
    {
        id: socialShareTypes.LINKEDIN,
        label: "Linkedin",
        icon: "cleverstory-linkedin",
        url: "https://linkedin.com/",
    },
    {
        id: socialShareTypes.TWITTER,
        label: "X(Twitter)",
        icon: "cleverstory-twitter",
        url: "https://x.com/",
    },
    {
        id: socialShareTypes.FACEBOOK,
        label: "Facebook",
        icon: "cleverstory-facebook",
        url: "https://www.facebook.com/",
    },
    {
        id: socialShareTypes.WHATSAPP,
        label: "Whatsapp",
        icon: "cleverstory-whatsapp",
        url: "https://web.whatsapp.com/",
    },
];
